module.exports = __webpack_public_path__ + "images/collapsed.png?cbfc249e37bc5807eb27046a47927f3f";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/collapsed.png
// module id = 98
// module chunks = 0